// Mock data for Carolina & Bill Law Firm

export const firmInfo = {
  name: "Carolina & Bill Law Firm",
  tagline: "GOT HURT? MAKE IT OUR FIGHT.",
  phone: "(517) 280-1816",
  phoneRaw: "5172801816",
  email: "contact@attorneycb.com",
  website: "https://attorneycb.com",
  address: "Bank of America Building, 1111 East Main Street, Suite 1900, Richmond, VA 23219",
  yearsExperience: 40,
  casesHandled: "10,000+",
  largestSettlement: "$12 Million",
  settlementTitle: "LARGEST WRONGFUL DEATH SETTLEMENT IN STATE HISTORY"
};

export const caseTypes = [
  {
    id: 1,
    title: "Passenger Accidents",
    description: "If another driver caused an accident, call an experienced lawyer. You may be entitled to compensation for your injuries.",
    image: "https://images.unsplash.com/photo-1493238792000-8113da705763?w=500&h=500&fit=crop"
  },
  {
    id: 2,
    title: "Whiplash Injuries",
    description: "Whiplash is one of the most common car accident injuries, and its symptoms can last for months or even years afterwards.",
    image: "https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=500&h=500&fit=crop"
  },
  {
    id: 3,
    title: "Nursing Home Negligence",
    description: "We have over 40 years of experience successfully representing nursing home neglect and abuse victims.",
    image: "https://images.unsplash.com/photo-1576765608535-5f04d1e3f289?w=500&h=500&fit=crop"
  },
  {
    id: 4,
    title: "Medical Malpractice",
    description: "If you suffered injuries, damages, or losses at the hands of a medical professional, our malpractice attorneys can help.",
    image: "https://images.unsplash.com/photo-1579684385127-1ef15d508118?w=500&h=500&fit=crop"
  },
  {
    id: 5,
    title: "Burn Injury",
    description: "Our attorneys know how burn injuries can affect almost every aspect of your life. We're here to help you quickly.",
    image: "https://images.unsplash.com/photo-1505751172876-fa1923c5c528?w=500&h=500&fit=crop"
  },
  {
    id: 6,
    title: "Wrongful Death Cases",
    description: "When a wrongful death occurs as a result of someone else's negligence, our attorneys fight for your rights.",
    image: "https://images.unsplash.com/photo-1589578527966-fdac0f44566c?w=500&h=500&fit=crop"
  },
  {
    id: 7,
    title: "Tractor Trailer Collisions",
    description: "Semi-truck accidents and 18-wheeler collisions can have devastating effects for victims.",
    image: "https://images.unsplash.com/photo-1601584115197-04ecc0da31d7?w=500&h=500&fit=crop"
  },
  {
    id: 8,
    title: "Automobile Crashes",
    description: "Over the past 40 years, our car accident attorneys have handled thousands of serious automobile accident cases.",
    image: "https://images.unsplash.com/photo-1583121274602-3e2820c69888?w=500&h=500&fit=crop"
  },
  {
    id: 9,
    title: "Motorcycle Accidents",
    description: "Car and tractor trailer drivers who don't keep a proper lookout for motorcycles need to be brought to justice.",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=500&h=500&fit=crop"
  },
  {
    id: 10,
    title: "Hit By Drunk Driver",
    description: "We've seen all too often the destruction that a drunk driver can do to a person's life, livelihood, and family.",
    image: "https://images.unsplash.com/photo-1542282088-72c9c27ed0cd?w=500&h=500&fit=crop"
  },
  {
    id: 11,
    title: "Uber & Lyft Cases",
    description: "If you were in an Uber or Lyft car accident, our rideshare accident lawyers will help get the justice you deserve.",
    image: "https://images.unsplash.com/photo-1449965408869-eaa3f722e40d?w=500&h=500&fit=crop"
  },
  {
    id: 12,
    title: "Catastrophic Injuries",
    description: "As with every case we handle, we fight for you from the very start of any catastrophic injury event.",
    image: "https://images.unsplash.com/photo-1516574187841-cb9cc2ca948b?w=500&h=500&fit=crop"
  },
  {
    id: 13,
    title: "Head & Brain Injuries",
    description: "Traumatic brain injury accident victims must have timely access to trauma care, and individualized legal representation.",
    image: "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=500&h=500&fit=crop"
  },
  {
    id: 14,
    title: "Spinal Injury & Paralysis",
    description: "Our attorneys successfully represent clients who have suffered severe spinal injuries, herniated discs, or paralysis.",
    image: "https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?w=500&h=500&fit=crop"
  },
  {
    id: 15,
    title: "Slip & Fall Cases",
    description: "Trial-tested experience successfully representing severely injured individuals in slip and fall accidents.",
    image: "https://images.unsplash.com/photo-1517245386807-bb43f82c33c4?w=500&h=500&fit=crop"
  },
  {
    id: 16,
    title: "Pedestrian Accidents",
    description: "Our pedestrian accident attorneys are here to get you compensation for the injuries, losses, or wrongful death.",
    image: "https://images.unsplash.com/photo-1519214605650-76a613ee3245?w=500&h=500&fit=crop"
  },
  {
    id: 17,
    title: "Dog Bite Injuries",
    description: "Negligence can lead to dog bites and attacks. File a compensation claim for injuries after a dog bite.",
    image: "https://images.unsplash.com/photo-1587300003388-59208cc962cb?w=500&h=500&fit=crop"
  },
  {
    id: 18,
    title: "Commercial Vehicle Accidents",
    description: "If you have been the victim of a commercial vehicle accident, we will fight to get you the compensation you deserve.",
    image: "https://images.unsplash.com/photo-1473042904451-00571f644e19?w=500&h=500&fit=crop"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Marcus",
    location: "Charlotte, NC",
    quote: "Carolina & Bill Law Firm is exceptional. If you want a really good team, they are the best attorneys I have ever seen!",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=200&h=200&fit=crop"
  },
  {
    id: 2,
    name: "Sarah",
    location: "Raleigh, NC",
    quote: "If you want compassion, integrity and high standards, there is only one place to go and that's Carolina & Bill. They did a fantastic job getting a great settlement on a very difficult case.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=200&h=200&fit=crop"
  },
  {
    id: 3,
    name: "Jennifer",
    location: "Durham, NC",
    quote: "The team was a blessing to me throughout the entire case. Professional and caring every step of the way.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=200&h=200&fit=crop"
  },
  {
    id: 4,
    name: "David",
    location: "Greensboro, NC",
    quote: "My experience with Carolina & Bill was fantastic. This really changed my life and my family's future.",
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=200&h=200&fit=crop"
  },
  {
    id: 5,
    name: "Michelle",
    location: "Winston-Salem, NC",
    quote: "I was very pleased with the way they handled my case from start to finish. Highly recommend!",
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=200&h=200&fit=crop"
  },
  {
    id: 6,
    name: "Robert",
    location: "Asheville, NC",
    quote: "The attorneys were right there helping me every step of the way. Outstanding service!",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=200&h=200&fit=crop"
  }
];

export const results = [
  {
    id: 1,
    category: "Head & Brain Injury",
    amount: "$12M",
    link: "/case-types/head-brain-injuries"
  },
  {
    id: 2,
    category: "Tractor Trailer Accidents",
    amount: "$8.5M",
    link: "/case-types/tractor-trailer-accidents"
  },
  {
    id: 3,
    category: "Catastrophic Injury",
    amount: "$6.2M",
    link: "/case-types/catastrophic-injuries"
  },
  {
    id: 4,
    category: "Wrongful Death",
    amount: "$5.8M",
    link: "/case-types/wrongful-death"
  },
  {
    id: 5,
    category: "Medical Malpractice",
    amount: "$4.5M",
    link: "/case-types/medical-malpractice"
  },
  {
    id: 6,
    category: "Automobile Crash",
    amount: "$3.2M",
    link: "/case-types/automobile-crashes"
  }
];

export const navLinks = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  { name: "Case Types", path: "/case-types" },
  { name: "Our Results", path: "/results" },
  { name: "Testimonials", path: "/testimonials" },
  { name: "Contact", path: "/contact" }
];

export const heroImages = {
  main: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=1920&h=1080&fit=crop",
  overlay: "https://images.unsplash.com/photo-1505664194779-8beaceb93744?w=1920&h=1080&fit=crop"
};

export const aboutContent = {
  title: "Welcome to Carolina & Bill Law Firm",
  mainText: `Imagine justice for you and your family. By contacting the experienced personal injury attorneys at Carolina & Bill Law Firm, you will have the power of over 40 years of trial tested experience on your side. We do not represent big business and we do not work for the insurance industry. All we do is work for good people like you who have been injured through no fault of their own. At Carolina & Bill we are experienced personal injury attorneys who have a passion to imagine justice for you and your family. We sympathize with the trauma you have gone through and we truly want the best possible outcome for your personal injury case.`,
  highlight: "We will come to you and there is no legal fee unless we win your case.",
  secondaryText: `At Carolina & Bill, we believe there is no more noble cause than representing the rights of the injured. We are on the cutting edge of legal advocates, protecting the rights of people like you who have become victims of reckless tractor trailer operators, negligent drivers, bad doctors, nursing homes, big business and/or an oppressive insurance industry.`,
  whyChooseUsImage: "https://images.unsplash.com/photo-1521791136064-7986c2920216?w=600&h=400&fit=crop",
  whatToExpectImage: "https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=600&h=400&fit=crop"
};
